import { render } from "./legup-waitlist.vue?vue&type=template&id=17598ce4&scoped=true"
import script from "./legup-waitlist.vue?vue&type=script&lang=js"
export * from "./legup-waitlist.vue?vue&type=script&lang=js"

import "./legup-waitlist.vue?vue&type=style&index=0&id=17598ce4&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17598ce4"]])

export default __exports__